module.exports = __webpack_public_path__ + "images/landing/banner/help-img-7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-7.png
// module id = Jqsy
// module chunks = 153